import controller from '../../../../Resources/Scripts/_Shared/controller';

import React, { useContext, useEffect, useState, Fragment } from 'react';
import ReactDOM from 'react-dom';

import { useJsApiLoader } from '@react-google-maps/api';
import { CityPageContextProvider, CityPageContext } from './CityPageContext';

import MapWidget from './partials/Map';
import LoadingScreenWidget from './partials/LoadingScreen';

function cityPage(context) {

  let country = document.querySelector('html').getAttribute('country');
  const appConfig = controller.getConfig(context);
  let facilities = appConfig.facilities;

  for (let i = 0; i < facilities.length; i++) {
    facilities[i].Address.Marker.Coordinates.lat = parseFloat(facilities[i].Address.Marker.Coordinates.lat);
    facilities[i].Address.Marker.Coordinates.lng = parseFloat(facilities[i].Address.Marker.Coordinates.lng);
    facilities[i].hasLtp = facilities[i].hasLtp.toLowerCase() === 'true';
    facilities[i].hasStp = facilities[i].hasStp.toLowerCase() === 'true';
    facilities[i].indoor = facilities[i].indoor.toLowerCase() === 'true';
    facilities[i].info.heated = facilities[i].info.heated.toLowerCase() === 'true';
  }

  let selectedLocationFallback = {
    position: {
      lat: appConfig.city.latitude ? parseFloat(appConfig.city.latitude) : null,
      lng: appConfig.city.longitude ? parseFloat(appConfig.city.longitude) : null
    }
  };

  const App = ({ isLoaded }) => {

    const { cityPageContext, setCityPageContext } = useContext(CityPageContext);
    const [viewToggle, setViewToggle] = useState('list');

    useEffect(() => {
      let isSubscribed = true;
      const getFacilities = async () => {

        const urlParams = new URLSearchParams(window.location.search);
        const selectedLocation = urlParams.get('lat') && urlParams.get('lng') ? {
          position: {
            lat: urlParams.get('lat') && parseFloat(urlParams.get('lat')),
            lng: urlParams.get('lng') && parseFloat(urlParams.get('lng')),
          },
        } : selectedLocationFallback;

        //const selectedLocation = selectedLocationFallback;
        const lastKnownLocation = selectedLocation.position;

        setCityPageContext({
          ...cityPageContext,
          ...appConfig,
          country,
          allFacilities: facilities,
          filteredFacilities: facilities,
          selectedLocation,
          lastKnownLocation,
          panOnLoad: false,
          showLoadingScreen: facilities.length ? true : false
        });
      }

      getFacilities();

      return () => isSubscribed = false;
      
    }, []);

    if (!isLoaded || !cityPageContext.selectedLocation) {
      return <LoadingScreenWidget />
    }

    return (
      <Fragment>
        <MapWidget
          isLoaded={isLoaded}
          cityPageContext={cityPageContext}
          setCityPageContext={setCityPageContext}
          viewToggle={viewToggle}
          setViewToggle={setViewToggle}
        />
      </Fragment>
    );
  }

  const ProviderWrapper = ({ scriptLib }) => {
    const { isLoaded } = useJsApiLoader(scriptLib);

    return (
      <CityPageContextProvider>
        <App isLoaded={isLoaded} />
      </CityPageContextProvider>
    )
  }

  function init() {
    const scriptLib = {
      googleMapsApiKey: appConfig.episerver.apikey,
      libraries: ['places', 'marker']
    };
    ReactDOM.render(<ProviderWrapper scriptLib={scriptLib} />, context);
  }

  return {
    init
  };
}

controller.add('city-page', cityPage);